<template lang="pug">
.revenue-page.flex.stretch
  .navbar.flex.column
    .nav.clickable.flex.align-center.justify-center(
      v-for="child in showRevenuePages"
      :class="{'active': child.name === menu}"
      @click="goPage(child)"
    ) {{ child.title }}
  router-view.sub-content
</template>

<script>
import { mapGetters } from 'vuex';
import revenueChildren from '@/site/management/router/revenue';
import { isRouteAllowed } from '@/site/management/router/access';

export default {
  data() {
    return {
      revenueChildren,
      menu: 'revenueLabel',
    };
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
  computed: {
    ...mapGetters(['isAdmin', 'isAccounting', 'user']),
    showRevenuePages() {
      // 與路由守衛共用同一份權限設定（adminOnly / roles），見 router/access.js
      return revenueChildren.filter((child) => child.showInMenu && isRouteAllowed(child, this.user?.role));
    },
  },
  methods: {
    checkRoute() {
      if (this.$route.name === 'Revenue') {
        this.goDftPage();
      } else {
        this.showRevenuePages.forEach((child) => {
          if (this.$route.name.indexOf(child.name) >= 0) {
            this.menu = child.name;
          }
        });
      }
    },
    goPage(child) {
      this.menu = child.name;
      this.$router.push({ name: child.name });
    },
    goDftPage() {
      this.$router.push(`/revenue/${this.showRevenuePages[0].path}`);
    },
  },
  mounted() {
    if (!this.isAdmin && !this.isAccounting) {
      this.$router.push('/reserve');
      return;
    }
    this.checkRoute();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.navbar {
  flex: 0 0 145px;
  padding: 20px;
  padding-right: 0;
  border-right: 1px solid $border-light-color;
  .nav {
    flex: 0 0 48px;
    margin-right: -1px;
    &.active {
      color: $primary-color;
      border-right: 1px solid $primary-color;
    }
  }
}
.sub-content {
  padding: 30px;
  flex: 1;
  overflow: hidden;
}
</style>
